module.exports = "https://www.gc-qa.gnp.com.mx/e3844dbd8f867c991dcbda0dbeb44eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-20.jpg
// module id = 948
// module chunks = 0 1